import React from 'react';

import Layout from 'components/Layout';
import SellAvto from 'components/Landings/SellAvto';
import { makeLocalize } from 'locales';

import { isAuthenticated } from '../../auth';
import messages from './messages';

async function action({ store, fetch, intl }) {
  const localize = makeLocalize(intl, messages);

  const title = localize('Продати авто на Avtoprod - це легко');
  const description = localize(
    'Швидко та легко продати авто на Avtoprod.ua. Продай автомобіль швидко та за вигідною ціною. Даруємо 300 грн на просування вашого авто.',
  );

  if (await isAuthenticated(store, fetch)) {
    return { redirect: '/add' };
  }

  return {
    chunks: ['site'],
    title,
    description,
    component: (
      <Layout breadcrumbs={false}>
        <SellAvto />
      </Layout>
    ),
  };
}

export default action;
